import lazyScreen from '../utils/lazyScreen';
const HRWorkingSalary = lazyScreen(() => import('../pages/payroll/HRWorkingSalary/index.js'), 'pages/payroll/HRWorkingSalary/index.js');
const HRWorkingSalarys = lazyScreen(() => import('../pages/payroll/HRWorkingSalarys/index.js'), 'pages/payroll/HRWorkingSalarys/index.js');
const HRAdjust = lazyScreen(() => import('../pages/payroll/HRAdjust/index.js'), 'pages/payroll/HRAdjust/index.js');
const HRAdjusts = lazyScreen(() => import('../pages/payroll/HRAdjusts/index.js'), 'pages/payroll/HRAdjusts/index.js');
const HRCommision = lazyScreen(() => import('../pages/payroll/HRCommision/index.js'), 'pages/payroll/HRCommision/index.js');
const HRCommisions = lazyScreen(() => import('../pages/payroll/HRCommisions/index.js'), 'pages/payroll/HRCommisions/index.js');
const HRAllowance = lazyScreen(() => import('../pages/payroll/HRAllowance/index.js'), 'pages/payroll/HRAllowance/index.js');
const HRAllowances = lazyScreen(() => import('../pages/payroll/HRAllowances/index.js'), 'pages/payroll/HRAllowances/index.js');
const HROvertime = lazyScreen(() => import('../pages/payroll/HROvertime/index.js'), 'pages/payroll/HROvertime/index.js');
const HROvertimes = lazyScreen(() => import('../pages/payroll/HROvertimes/index.js'), 'pages/payroll/HROvertimes/index.js');
const HROrder = lazyScreen(() => import('../pages/payroll/HROrder/index.js'), 'pages/payroll/HROrder/index.js');
const HROrders = lazyScreen(() => import('../pages/payroll/HROrders/index.js'), 'pages/payroll/HROrders/index.js');
const HRPayments = lazyScreen(() => import('../pages/payroll/HRPayments/index.js'), 'pages/payroll/HRPayments/index.js');

export default [
    {
        path: '/payroll/HRWorkingSalary/:code',
        component: HRWorkingSalary
    },
    {
        path: '/payroll/HRWorkingSalarys',
        component: HRWorkingSalarys
    },
    {
        path: '/payroll/HRAdjusts',
        component: HRAdjusts
    },
    {
        path: '/payroll/HRAdjust/:code',
        component: HRAdjust
    },
    {
        path: '/payroll/HRCommisions',
        component: HRCommisions
    },
    {
        path: '/payroll/HRCommision/:code',
        component: HRCommision
    },
    {
        path: '/payroll/HRAllowances',
        component: HRAllowances
    },
    {
        path: '/payroll/HRAllowance/:code',
        component: HRAllowance
    },
    {
        path: '/payroll/HROvertimes',
        component: HROvertimes
    },
    {
        path: '/payroll/HROvertime/:code',
        component: HROvertime
    },
    {
        path: '/payroll/HROrders',
        component: HROrders
    },
    {
        path: '/payroll/HROrder/:code',
        component: HROrder
    },
    {
        path: '/payroll/HRPayments',
        component: HRPayments
    }
];
